import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonViewWithBadge} from './UIGameActionButtonViewWithBadge'
import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, PieceTypes} from '@colonist/game-base-types'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {getCardsForPiece} from '@colonist/game-card-types'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {ActionState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'

export class UIGameActionButtonViewKnightUpgrade extends UIGameActionButtonViewWithBadge {
    private readonly parentButton: UIGameActionButtonView
    private readonly knightPlayerValidator: MechanicValidatorKnightPlayer

    constructor(uiGameManager: UIGameManager, container: PIXI.Container, parentButton: UIGameActionButtonView, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        const amountOfKnightsThatCanBeUpgrade = knightPlayerValidator.getAmountOfKnightsEligibleForUpgrade()
        const preferredPosition = 3
        super(uiGameManager, preferredPosition, container, amountOfKnightsThatCanBeUpgrade)
        this.parentButton = parentButton
        this.knightPlayerValidator = knightPlayerValidator

        const swordTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_active_level1)
        const swordX = this.width * 0.2
        const swordY = 0
        const swordH = this.height * 0.6
        const swordW = swordTexture.width / swordTexture.height * swordH
        const swordIcon = new SpriteView(swordX, swordY, swordW, swordH, this.viewContainer, swordTexture)
        this.addAsset(swordIcon)
        this.centerIconInY(swordIcon)

        const arrowTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_arrow_white)
        const arrowX = this.width * 0.4
        const arrowY = 0
        const arrowH = this.height * 0.55
        const arrowW = arrowTexture.width / arrowTexture.height * arrowH
        const arrowIcon = new SpriteView(arrowX, arrowY, arrowW, arrowH, this.viewContainer, arrowTexture)
        arrowIcon.rotate(-90)
        arrowIcon.x = this.width * 0.65
        arrowIcon.y = this.height * 0.5
        this.addAsset(arrowIcon)

        this.setUpdateAction()
        this.stateUpdated()
        const cardsToUpgradeKnight = getCardsForPiece(PieceTypes.Knight)
        this.setHoverAction(cardsToUpgradeKnight)
        this.setTip({key: 'strings:game.tooltips.upgradeKnight'}, [{key: 'strings:colonistCommon.utils.emptyString'}])
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.KnightStateUpdated:
                this.stateUpdated()
                this.playerStateUpdated()
                break
            case UIGameEventEnums.GameStateUpdated: this.stateUpdated(); break
            case UIGameEventEnums.ShowTradeUI: this.cancelBuild(); break
            default: break
        }
    }

    protected playerStateUpdated() {
        const amountOfKnightsThatCanBeUpgraded = this.knightPlayerValidator.getAmountOfKnightsEligibleForUpgrade()
        this.updateBadgeCount(amountOfKnightsThatCanBeUpgraded)
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedKnightUpgrade()
        })
    }

    private clickedKnightUpgrade() {
        if(this.cancelBuild()) return

        const canPlayerUpgradeKnight = this.knightPlayerValidator.canPlayerUpgradeKnight()
        if(!this.canPerformBuyAction(canPlayerUpgradeKnight)) return

        this.uiGameManager.socketGameSend.upgradeKnight()
    }

    private cancelBuild(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.UpgradeKnight) return false

        this.uiGameManager.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight)
        this.uiGameManager.socketGameSend.cancelAction()
        return true
    }

    protected stateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.canPlayerUpgradeKnight()) return

        this.updateOpacityForTurnState()
        this.updateHighlightForActionState()
    }

    private canPlayerUpgradeKnight(): boolean {
        const canPlayerUpgradeKnight = this.knightPlayerValidator.canPlayerUpgradeKnight()
        return canPlayerUpgradeKnight.canTakeAction
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
        this.parentButton.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private updateHighlightForActionState() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.UpgradeKnight) return
        this.activateOpacity()
        this.highlight()
    }
}
